import { Component, OnInit } from '@angular/core';
import { CountryDiseaseModel } from '../../../models/master-data/countries-diseases.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { DialogService } from '../../../shared/services/dialog.service';
import { CountriesDiseasesService } from './countries-diseases.service';
import { AddNewCountryDiseaseComponent } from './add-new-country-disease.component';
import { DiseaseModel } from '../../../models/master-data/diseases.model';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';
import { ModifyCountryDiseaseComponent } from './modify-country-disease.component';

@Component({
    selector: 'countries-diseases-list',
    templateUrl: 'countries-diseases-list.component.html',
    providers: [CountriesDiseasesService]
})

export class CountriesDiseasesListComponent extends TMBDataTableComponent implements OnInit {
    filterData = {
        countryId: '',
        countryName: '',
        diseaseName: ''
    };
    dataRow = new Array<DiseaseModel>();
    countries: any;

    constructor( public sharedService: SharedService,
        public dialogService: DialogService,
        public utility: Utility,
        private countriesDiseasesService: CountriesDiseasesService) {
            super(sharedService);
        }

    ngOnInit() {
        this.countriesDiseasesService.getCountryList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.countries = data['list'];
                    // set default filter is first element list
                    if (this.countries.length > 0) {
                        this.filterData.countryId = this.countries[0].countryId;
                        this.filterData.countryName = this.countries[0].countryName;
                    }
                    this.setPage({ offset: 0 });
                }
            },
            error => {
            }
        );
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            countryId: this.filterData.countryId === 'null' ? '' : this.filterData.countryId,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            diseaseName: this.filterData.diseaseName
        };
        this.countriesDiseasesService.getDiseasesByCountry(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => {
            }
        );
    }

    onFilter() {
        this.setPage({ offset: 0 });
    }

    onCountryChange() {
        this.countries.forEach(item => {
            if (item.countryId === this.filterData.countryId) {
                this.filterData.countryName = item.countryName;
            }
        });
        this.filterData.diseaseName = '';
        this.setPage({ offset: 0 });
    }

    onRemoveItem(id) {
      this.dialogService.openConfirmationDialog({message: AppMessages.countriesDiseases.removeCountriesDiseases}).subscribe(
        (result) => {
        if (result) {
            this.countriesDiseasesService.deleteCountryDisease(this.filterData.countryId, id).subscribe(
                deleteResult => {
                  if (deleteResult) {
                    this.reloadPage(this.page.pageNumber, this.dataRow, true);
                  }
                }
              );
        }
      });
    }

    onEditItem(id) {
      const data = {
          id : id,
          countryId: this.filterData.countryId,
          countryName: this.filterData.countryName,
          dataList: this.dataRow
      };
      this.dialogService.openComponentDialog(ModifyCountryDiseaseComponent, data).subscribe(
          (result) => {
              if (result) {
                this.reloadPage(this.page.pageNumber, this.dataRow);
              }
          }
      );
  }


    addNewCountryDiseases() {
        const data = {
            countryId: this.filterData.countryId,
            countryName: this.filterData.countryName,
            dataList: this.dataRow
        };
        this.dialogService.openComponentDialog(AddNewCountryDiseaseComponent,
            data).subscribe(
                (result) => {
                    if (result) {
                      this.reloadPage(this.page.pageNumber, this.dataRow);
                    }
                });
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/countries-diseases/countries-diseases-list.component.ts